export default __webpack_public_path__ + "static/media/avatar_cow2.74c248b3.mp3";